// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 203) return "static/chunks/e3762d72-ee78ba5b245f9ffa.js";
	if (chunkId === 147) return "static/chunks/147-24c43f482dadc7ee.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"5aaa550761b04abb","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"4a0463aeef0c6980","367":"15239566446ddabd","639":"e7b660adfa99260e","748":"6aa77528dd767fd9"}[chunkId] + ".js";
};